import { createOpenThread, createSharedResource, threadId } from './common/store';
import type { AppContact, AppOverview } from './common/types';

// Ansprechpartner und Zähler aller Firmen dieses Logins, gemeinsam für Kopfzeile, Übersicht, Seitenleiste und Liste.
export const appChat = createSharedResource<AppOverview>('/api/app/chat');
export const appOpenThread = createOpenThread();

export interface ContactOfFirm extends AppContact {
  clientId: string;
}

export function allContacts(data: AppOverview | undefined): ContactOfFirm[] {
  return (data?.firms ?? []).flatMap((f) => f.contacts.map((c) => ({ ...c, clientId: f.clientId })));
}

// Ungelesen gesamt. Der offene Chat zählt nicht (er wird beim Ansehen als gelesen markiert).
export function unreadOf(c: ContactOfFirm, open: string | null): number {
  return threadId(c.clientId, c.id) === open ? 0 : c.unread;
}

// Beschreibbare Ansprechpartner aller Firmen, jede Person einmal
export function writableContacts(data: AppOverview | undefined): ContactOfFirm[] {
  const seen = new Set<string>();
  return allContacts(data).filter((c) => !c.old && !seen.has(c.id) && seen.add(c.id));
}

// „Finanzbuchhaltung“ → „FiBu“, „Lohn & Gehalt“ → „Lohn“, „Kanzleileitung · zurzeit auch …“ → „Kanzleileitung“
export function shortRole(role: string): string {
  return (role.split(' · ')[0] ?? role).replace('Finanzbuchhaltung', 'FiBu').replace('Lohn & Gehalt', 'Lohn');
}

export const chatPath = (clientId: string, staffId: string) => `/app/nachrichten/${clientId}/${staffId}`;
